import { gql } from '@apollo/client/core'

export const uploadUserDesignMutation = gql`
  mutation uploadUserDesignMutation ($input: UploadUserDesignInput!) {
    uploadUserDesign(input: $input) {
      userUploadImageUuids
      errors
    }
  }
`
export const createDesignMutation = gql`
  mutation createDesignMutation ($input: CreateUserDesignInput!) {
    createUserDesign(input: $input) {
      userDesign {
        uuid
        imageUrl
        isDefault
        fileExtension
        nonTransparentVersion {
          uuid
          imageUrl
        }
        transparentVersion {
          uuid
          imageUrl
        }
        supportedTransparency
      }
    }
  }
`

// categoryId is optional, categoryId = 27 is by default from server
// for local, add library_default_category_id: { id } in development.local.yml
export const fullColorProductsByCategoryQuery = gql`
  query fullColorProductsByCategory(
    $categoryId: ID
    $offset: Int!
    $limit: Int!
  ) {
    fullColorProductsByCategory(
      categoryId: $categoryId
      offset: $offset
      limit: $limit
    ) {
      products {
        id
        productImage
      }
      totalItemsCount
    }
  }
`

export const initStockLibraryQuery = gql`
  query initStockLibraryQuery {
    userDesigns {
      uuid
      imageUrl
      isDefault
      fileExtension
      nonTransparentVersion {
        uuid
        imageUrl
      }
      transparentVersion {
        uuid
        imageUrl
      }
    }
    fullColorCategories {
      id
      displayName
      fullColorChildCategories {
        id
        displayName
        iconImage
      }
    }
    fullColorProductsByCategory(offset: 0, limit: 20) {
      category {
        id
        displayName
      }
      products {
        id
        productImage
      }
      totalItemsCount
    }
    editPatterns {
      id
      displayName
    }
  }
`

export const crossSellDataQuery = gql`
  query crossSellData {
    crossSellLogoDesign {
      imageUrl
    }
    crossSellLogoNamingEditors {
      displayHeight
      displayName
      displayOrder
      displayWidth
      height
      heightMm
      id
      left
      thumbnail
      top
      width
      widthMm
    }
}`

export const productDetailQuery = gql`
  query stockLibrary_ProductDetail ($id: ID!) {
    productByPrintableSku(id: $id) {
      product {
        displayName
        brand
        gender
        lowestPrice
        quantityUnit
        url
      }
      sku {
        firstOptions {
          id
          thumbnail
          selectable
          lead
        }
        allSingleSkuEditPatterns {
          id
          editPattern {
            id
            displayName
          }
          namingEditors {
            id
            thumbnail
            width
            height
            displayHeight
            displayWidth
            top
            left
          }
        }
      }
    }
  }
`

export const productSkuEditPatternsQuery = gql`
  query stockLibrary_ProductSkuEditPatterns($id: ID!, $firstOption: ID!) {
    productByPrintableSku(id: $id, firstOptionId: $firstOption) {
      sku {
        allSingleSkuEditPatterns {
          id
          editPattern {
            id
            displayName
          }
          namingEditors {
            id
            thumbnail
            width
            height
            displayHeight
            displayWidth
            top
            left
          }
        }
      }
    }
  }
`

export const categoryEditPatternQuery = gql`
  query stockLibrary_CategoryEditPattern($categoryId: ID!) {
    editPatterns(categoryId: $categoryId) {
      id
      displayName
    }
  }
`
